equalheight = function (container) {

        var currentTallest = 0,
            currentRowStart = 0,
            rowDivs = new Array(),
            $el,
            topPosition = 0;
        jQuery(container).each(function () {
            var $el = jQuery(this);

            jQuery($el).height('auto')

			var topPostion = $el.position().top;

            if (currentRowStart != topPostion) {
                for (var currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
                    rowDivs[currentDiv].height(currentTallest);
                }
                rowDivs.length = 0; // empty the array
                currentRowStart = topPostion;
                currentTallest = $el.height();
                rowDivs.push($el);
            } else {
                rowDivs.push($el);
                currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
            }
            for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
                rowDivs[currentDiv].height(currentTallest);
            }
        });
    }

function setEqHeight() {
	equalheight('.locations .col-md-6');
	equalheight('.footer-box');
	equalheight('.eqHeight');
    equalheight('.attorney-thumbnail');
    equalheight('.section-contact-form-box');
}

jQuery(document).ready(function ($) {

    $('.sameHeight').matchHeight();

    $('#menu-mobile-menu .dropdown-toggle').on('click',function () {
        $(this).next().slideToggle();
    });

    $('.qa-faq-anchor').on('click',function (e) {
        e.preventDefault();
        $(this).toggleClass('active');
    });

    $('.input-email').on('focus', function () {
        if ($(this).parent().data('required') == 'required') {
            $(this).parent().removeClass('required');
        }
    });

    $('.input-email').on('blur', function () {
        if ($(this).val() == '') {
            $(this).parent().addClass('required');
        }
    });

    $(".btn-menu").on("click",function() {
        //$(".header-top-wrap").toggleClass("nav-active");
        $("#mobile-nav .collapse").slideToggle();
    });

    //Skip Link
    var skipLink = function () {
        $(".skiplink").focusin(function () {
            $(this).css("position", "static");
        });

        $(".skiplink").focusout(function () {
            $(this).css("position", "absolute");
        });
    };

    //Navigation
    $('.nav-opener').click(function () {
        $('#m-toggle').toggleClass('.nav-active menu');
    });

    //FAQ Plugin JS
    $('.qa_cats').remove();

    var anchor = $('.qa-faq-anchor');

    anchor.click(function () {
        $('.faq-active').removeClass('faq-active');
        $('.qa-faq-anchor').removeClass('faq-active');
        $(this).toggleClass('faq-active');
    });

    //Table of Contents Builder

    var ToC =
  "<nav role='navigation' class='toc'>" +
    "<h3 class='toc-title'>Table of Contents</h3>" +
    "<ul class='sb-list'>";

    var newLine, el, title, link;

    $(".toc-heading").each(function() {

          el = $(this);
          title = el.text();
          link = "#" + el.attr("id");

          newLine =
            "<li>" +
              "<a class='toc-link' href='" + link + "'>" +
                title +
              "</a>" +
            "</li>";

          ToC += newLine;

    });

    ToC +=
       "</ul>" +
      "</nav>";

    $(".toc-wrap").prepend(ToC);

    //Toc link clic
    $( '.toc-link' ).on( 'click', function(e) {
        var goTo = $(this).attr('href');
        $('html,body').animate({ scrollTop: $(goTo).offset().top }, 600);

    });

    //No comments
    $("#commentform").addClass("noauto");

    //Navigation
    $(".nav-opener").on("click", function () {
        $(".header-top-wrap").toggleClass("nav-active");
    });

    $('.footer-accordion-link').click(function (e) {
        e.preventDefault();
        $.ajax({
            type: 'POST',
            url: cws.ajaxurl,
            data: {
                action: 'cws_map_link_ajax_callback',
                map_id: $(this).attr('data-id')
            },
            dataType: 'json',

		success: function (response) {
			if( response.success === true ) {
			  var arr = response.data.shortCode.split('#');
			  map = new google.maps.Map(document.getElementById('map_canvas'), {
				zoom: 15,
				center: {lat: parseFloat(arr[0]), lng: parseFloat(arr[1])},
				mapTypeId: 'roadmap'
			  });

			  var marker;
              marker = new google.maps.Marker({
                position: new google.maps.LatLng(parseFloat(arr[0]),parseFloat(arr[1])),
                map: map,
                icon: '/wp-content/themes/cws-theme-work/images/icons/map-icon.png'
              });
              marker.setMap(map);

                } else if (response.success === false) {
                    alert(response.data);
                }
            },
        });
    });

    // Play video on play

    $(".modal").on('shown.bs.modal', function (ev) {
        var $this2 = $(this);
        var $frame2 = $this2.find('.modal-content #video_play iframe');
        $frame2[0].src += "1";
    });

    //Stop video on play

    $(".modal").on('hidden.bs.modal', function (e) {
        var $this = $(this);
        var $frame = $this.find('.modal-content #video_play iframe');
        $frame.attr("src", $frame.attr("src").replace("autoplay=1", "autoplay="));
        //$frame.attr("src", $frame.attr("src"));
    });

    //Hover for Desktop, click for mobile nav
    if ($(window).width() > 767) {
        $('.dropdown').on('mouseenter mouseleave click tap', function () {
            $(this).toggleClass("open");
        });
    }

    //Slick

    $("#result-slide").slick({
        slidesToShow: 3,
        infinite: true,
        autoplay: false,
        slidesToScroll: 3,
        //prevArrow: '<span class="icon-chevron-left-green"></span>',
        //nextArrow: '<span class="icon-chevron-right-green"></span>',
        //appendArrows: '.customNavigationResults',
        dots: false,
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    //centerMode: true,
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    //centerMode: true,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    //centerMode: true
                }
            }
        ]
    });

    $("#quote-slide").slick({
        infinite: true,
        arrows: false,
        appendDots: '.customDots',
        dots: true,
    });

    $("#practice-slide").slick({
        slidesToShow: 5,
        infinite: false,
        autoplay: false,
        slidesToScroll: 5,
        initialSlide: 0,
        prevArrow: '<span class="icon-chevron-left-green"></span>',
        nextArrow: '<span class="icon-chevron-right-green"></span>',
        appendArrows: '.customNavigationPractices',
        dots: false,
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    //centerMode: true,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: 0,
                }
            }

        ],
    });

    $("#attorney-slides").slick({
        slidesToShow: 4,
        infinite: false,
        autoplay: false,
        slidesToScroll: 4,
        initialSlide: 0,
        //prevArrow: '<span class="icon-chevron-left-green"></span>',
       // nextArrow: '<span class="icon-chevron-right-green"></span>',
        //appendArrows: '.customNavigationPractices',
        dots: false,
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    //centerMode: true,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: 0,
                }
            }

        ],
    });

});

jQuery(window).load(function () {
    setEqHeight();
    jQuery('.wf-active').css({'opacity': "0"});
    jQuery('.wf-active').attr('style', 'opacity: 1 !important');
});

jQuery(window).resize(function () {
    setEqHeight();
});
